import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import LoginLayout from '../../layouts/login';
// locales
import { useLocales } from '../../locales';
//
import AuthLoginForm from './AuthLoginForm';
import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  const { translate } = useLocales();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">{`${translate('login.title')}`}</Typography>

        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2">{`${translate('login.new_user')}`}</Typography>

          <Link component={RouterLink} to={PATH_AUTH.register} variant="subtitle2">
            {`${translate('login.create_account')}`}
          </Link>
        </Stack>

        <Tooltip title={method} placement="left">
          <Box
            component="img"
            alt={method}
            src={`/assets/icons/auth/ic_${method}.png`}
            sx={{ width: 32, height: 32, position: 'absolute', right: 0 }}
          />
        </Tooltip>
      </Stack>

      {/* <Alert severity="info" sx={{ mb: 3 }}>
        Use email : <strong>demo@learmonade.com</strong> password :<strong> demo1234</strong>
      </Alert> */}

      <AuthLoginForm />

      <AuthWithSocial />
    </LoginLayout>
  );
}
